var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128",
    width: "128px",
    height: "128px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 12.09375,
    x2: 86,
    y2: 162.529251,
    gradientTransform: "matrix(0.744186,0,0,0.744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,11.372549%,55.686277%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(69.411767%,16.470589%,35.686275%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 116.90625,
    y1: 12.09375,
    x2: 116.90625,
    y2: 162.529251,
    gradientTransform: "matrix(0.744186,0,0,0.744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,11.372549%,55.686277%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(69.411767%,16.470589%,35.686275%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 55.09375,
    y1: 12.09375,
    x2: 55.09375,
    y2: 162.529251,
    gradientTransform: "matrix(0.744186,0,0,0.744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,11.372549%,55.686277%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(69.411767%,16.470589%,35.686275%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 12.09375,
    x2: 86,
    y2: 162.529251,
    gradientTransform: "matrix(0.744186,0,0,0.744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,11.372549%,55.686277%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(69.411767%,16.470589%,35.686275%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 110.1875,
    y1: 113.546883,
    x2: 110.1875,
    y2: 125.181061,
    gradientTransform: "matrix(0.744186,0,0,0.744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,55.29412%,77.254903%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(86.666667%,43.137255%,58.823532%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 123.625,
    y1: 73.739632,
    x2: 123.625,
    y2: 85.973129,
    gradientTransform: "matrix(0.744186,0,0,0.744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,55.29412%,77.254903%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(86.666667%,43.137255%,58.823532%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear6",
    gradientUnits: "userSpaceOnUse",
    x1: 61.8125,
    y1: 113.882812,
    x2: 61.8125,
    y2: 125.659439,
    gradientTransform: "matrix(0.744186,0,0,0.744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,55.29412%,77.254903%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(86.666667%,43.137255%,58.823532%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear7",
    gradientUnits: "userSpaceOnUse",
    x1: 48.375,
    y1: 73.234383,
    x2: 48.375,
    y2: 86,
    gradientTransform: "matrix(0.744186,0,0,0.744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,55.29412%,77.254903%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(86.666667%,43.137255%,58.823532%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear8",
    gradientUnits: "userSpaceOnUse",
    x1: 48.375,
    y1: 108.507812,
    x2: 48.375,
    y2: 119.97538,
    gradientTransform: "matrix(0.744186,0,0,0.744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,55.29412%,77.254903%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(86.666667%,43.137255%,58.823532%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear9",
    gradientUnits: "userSpaceOnUse",
    x1: 61.8125,
    y1: 79.114632,
    x2: 61.8125,
    y2: 91.264809,
    gradientTransform: "matrix(0.744186,0,0,0.744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,55.29412%,77.254903%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(86.666667%,43.137255%,58.823532%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface18605811"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 105.988281 29.257812 L 67.984375 12.734375 C 65.449219 11.632812 62.546875 11.632812 60.015625 12.734375 L 22.007812 29.257812 C 18.359375 30.847656 16 34.445312 16 38.425781 L 16 89.941406 C 16 93.921875 18.359375 97.519531 22.011719 99.105469 L 58.414062 114.933594 C 60.191406 115.707031 62.097656 116.09375 64 116.09375 C 65.902344 116.09375 67.808594 115.707031 69.585938 114.933594 L 105.992188 99.105469 C 109.640625 97.519531 112 93.921875 112 89.941406 L 112 38.425781 C 112 34.445312 109.640625 30.847656 105.988281 29.257812 Z M 61.613281 16.402344 C 62.371094 16.070312 63.1875 15.90625 64 15.90625 C 64.8125 15.90625 65.628906 16.070312 66.390625 16.402344 L 104.394531 32.925781 C 104.578125 33.007812 104.753906 33.109375 104.929688 33.207031 L 66.386719 49.960938 C 64.871094 50.621094 63.128906 50.621094 61.609375 49.960938 L 23.070312 33.207031 C 23.242188 33.109375 23.414062 33.007812 23.601562 32.925781 Z M 23.605469 95.4375 C 21.414062 94.484375 20 92.324219 20 89.941406 L 20 38.425781 C 20 37.714844 20.136719 37.035156 20.371094 36.390625 L 60.015625 53.628906 C 60.65625 53.90625 61.320312 54.113281 62 54.25 L 62 111.886719 C 61.320312 111.75 60.652344 111.542969 60.011719 111.265625 Z M 108 89.941406 C 108 92.324219 106.585938 94.484375 104.394531 95.4375 L 67.988281 111.265625 C 67.347656 111.546875 66.679688 111.75 66 111.890625 L 66 54.25 C 66.679688 54.113281 67.34375 53.90625 67.984375 53.628906 L 107.628906 36.390625 C 107.863281 37.035156 108 37.714844 108 38.425781 Z M 108 89.941406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 102.6875 44.167969 C 101.863281 43.613281 100.820312 43.496094 99.886719 43.875 L 71.882812 55.324219 C 70.738281 55.78125 70 56.871094 70 58.101562 L 70 101.71875 C 70 102.714844 70.488281 103.640625 71.3125 104.195312 C 71.8125 104.535156 72.394531 104.710938 72.984375 104.710938 C 73.363281 104.710938 73.746094 104.636719 74.113281 104.492188 L 102.125 93.035156 C 103.265625 92.578125 104 91.488281 104 90.261719 L 104 46.644531 C 104 45.648438 103.511719 44.722656 102.6875 44.167969 Z M 100 89.585938 L 74 100.214844 L 74 58.78125 L 100 48.148438 Z M 100 89.585938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 56.132812 55.328125 L 28.101562 43.867188 C 27.171875 43.5 26.136719 43.613281 25.3125 44.167969 C 24.488281 44.722656 24 45.648438 24 46.644531 L 24 90.261719 C 24 91.488281 24.734375 92.578125 25.875 93.035156 L 53.902344 104.496094 C 54.261719 104.636719 54.636719 104.707031 55.011719 104.707031 C 55.601562 104.707031 56.1875 104.535156 56.691406 104.195312 C 57.511719 103.636719 58 102.710938 58 101.71875 L 58 58.101562 C 58 56.871094 57.261719 55.78125 56.132812 55.328125 Z M 54 100.214844 L 28 89.585938 L 28 48.148438 L 54 58.777344 Z M 54 100.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 64 47.007812 C 64.539062 47.007812 65.070312 46.898438 65.570312 46.683594 L 97.074219 33.183594 L 65.570312 19.679688 C 64.570312 19.25 63.429688 19.25 62.429688 19.679688 L 30.925781 33.183594 L 62.429688 46.683594 C 62.929688 46.898438 63.460938 47.007812 64 47.007812 Z M 63.996094 23.355469 L 86.925781 33.183594 L 64.003906 43.007812 L 41.074219 33.183594 Z M 63.996094 23.355469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear4)"
    },
    d: "M 82 93.183594 C 79.792969 93.183594 78 91.386719 78 89.183594 C 78 86.976562 79.792969 85.183594 82 85.183594 C 84.207031 85.183594 86 86.976562 86 89.183594 C 86 91.386719 84.207031 93.183594 82 93.183594 Z M 82 89.179688 L 82 89.183594 Z M 82 89.179688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear5)"
    },
    d: "M 92 63.183594 C 89.792969 63.183594 88 61.386719 88 59.183594 C 88 56.976562 89.792969 55.183594 92 55.183594 C 94.207031 55.183594 96 56.976562 96 59.183594 C 96 61.386719 94.207031 63.183594 92 63.183594 Z M 92 59.179688 L 92 59.183594 Z M 92 59.179688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear6)"
    },
    d: "M 46 93.183594 C 43.792969 93.183594 42 91.386719 42 89.183594 C 42 86.976562 43.792969 85.183594 46 85.183594 C 48.207031 85.183594 50 86.976562 50 89.183594 C 50 91.386719 48.207031 93.183594 46 93.183594 Z M 46 89.183594 Z M 46 89.183594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear7)"
    },
    d: "M 36 63.183594 C 33.792969 63.183594 32 61.386719 32 59.183594 C 32 56.976562 33.792969 55.183594 36 55.183594 C 38.207031 55.183594 40 56.976562 40 59.183594 C 40 61.386719 38.207031 63.183594 36 63.183594 Z M 36 59.183594 Z M 36 59.183594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear8)"
    },
    d: "M 36 89.183594 C 33.792969 89.183594 32 87.386719 32 85.183594 C 32 82.976562 33.792969 81.183594 36 81.183594 C 38.207031 81.183594 40 82.976562 40 85.183594 C 40 87.386719 38.207031 89.183594 36 89.183594 Z M 36 85.183594 Z M 36 85.183594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear9)"
    },
    d: "M 46 67.183594 C 43.792969 67.183594 42 65.386719 42 63.183594 C 42 60.976562 43.792969 59.183594 46 59.183594 C 48.207031 59.183594 50 60.976562 50 63.183594 C 50 65.386719 48.207031 67.183594 46 67.183594 Z M 46 63.183594 Z M 46 63.183594 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDice);
export default __webpack_public_path__ + "static/media/dice.ddcbdfacf9667519c6c52bbaee5550ee.svg";
export { ForwardRef as ReactComponent };